import { Button, IconButton, Toolbar, Tooltip, Typography, alpha } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';


interface TablaInformesToolbar {
    numSelected: number;
    onLiquidarInformes: () => void
}

export function TablaInformeToolbar(props: TablaInformesToolbar) {
    const { numSelected, onLiquidarInformes } = props;

    return (
        <Toolbar
            sx={{
                pl: { sm: 2 },
                pr: { xs: 1, sm: 1 },
            }}
        >

            <Typography
                sx={{ flex: '1 1 100%' }}
                variant="h6"
                id="tableTitle"
                component="div"
            >
                Informes
            </Typography>

            {numSelected > 0 ? (
                <Tooltip title="Presiona aquí para liquidar">
                    <Button onClick={onLiquidarInformes} fullWidth sx={{ justifyContent: 'flex-end' }}>
                        Liquidar Informes
                    </Button>
                </Tooltip>
            ) : <></>}
        </Toolbar>
    );
}
